import store from 'util/data/store';
import formModel from 'models/form-model';
import measure from 'legacy/util/numbers/measure';
import isMetric from 'util/numbers/is-metric';
import round from 'util/numbers/round';

export default function(control, assetId) {
    const asset = store.assets[assetId],
        properties = asset.properties,
        metric = isMetric();
    let value = properties[control.fieldName];
    value = !!value || control.attributes.required
        ? round(metric ? value : measure.metersToFeet(value))
        : value;
    if (formModel.isReadOnlyControl(asset.assetTypeId, control)) {
        return <div class="eval-value">{value} {metric ? 'meters' : 'feet'}</div>;
    }
    return <div class="length-control">
        <input data-focus-id="1" type="number" class="number-input" value={value} step="any" oninput={e => {
            formModel.handleLength(e, control, assetId);
        }}/>
        <span class="number-metric">{metric ? 'meters' : 'feet'}</span>
    </div>;
}
